"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PanelContentSchema = void 0;
const zod_1 = require("zod");
const panel_account_1 = require("./panel-account");
const panel_difficulty_level_1 = require("./panel-difficulty-level");
const panel_language_1 = require("./panel-language");
const panel_subject_1 = require("./panel-subject");
const hash_1 = require("./hash");
const image_file_1 = require("./image-file");
// Схема для PanelContentType (partial, для использования в API)
exports.PanelContentSchema = zod_1.z.object({
  id: zod_1.z.string(),
  author: panel_account_1.PanelAccountSchema.optional(),
  slug: zod_1.z.string(),
  title: zod_1.z.string(),
  sub_title: zod_1.z.string().optional(),
  type: zod_1.z.number(),
  cover_id: zod_1.z.string(),
  cover: (0, hash_1.HashSchema)(image_file_1.ImageFileSchema).optional(),
  description: zod_1.z.string(),
  language_id: zod_1.z.number(),
  language: panel_language_1.PanelLanguageSchema.optional(),
  level: panel_difficulty_level_1.PanelDifficultyLevelSchema.optional(),
  subject_id: zod_1.z.number(),
  subject: panel_subject_1.PanelSubjectSchema,
  stats: zod_1.z.any().optional(),
  published_at: zod_1.z.date(),
  archived_at: zod_1.z.date(),
  created_at: zod_1.z.date()
});
